export default "/_next/static/images/product--contacts-legacy-80c66b8aa07c79f038efb5136e6f61ba.svg";